<div class="cards-data" [formGroup]="formNewItem">
  <p>{{ sectionLabel }}</p>

  <div class="inputs-card">
    <div class="input-forms inputs-time">
      <mat-form-field>
        <mat-label>Descrição do horário</mat-label>
        <input
          matInput
          placeholder="EX: Café da manhã."
          formControlName="description"
        />
        @if (formNewItem.controls.description.hasError('required')) {
          <mat-error>Descrição do horário é obrigatório</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Horário de início</mat-label>
        <input
          matInput
          type="time"
          placeholder="EX: 12:00"
          formControlName="startTime"
        />
        @if (formNewItem.controls.startTime.hasError('required')) {
          <mat-error>Horário de início é obrigatório</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Horário de término</mat-label>
        <input
          matInput
          type="time"
          placeholder="EX: 15:00"
          formControlName="endTime"
        />
        @if (formNewItem.controls.endTime.hasError('required')) {
          <mat-error>Horário de término é obrigatório</mat-error>
        }
        @if (formNewItem.controls.endTime.hasError('invalidTimeRange')) {
          <mat-error
          >Horário de término deve ser maior que o de início
          </mat-error
          >
        }
      </mat-form-field>

      <div class="btn-add">
        <img
          src="assets/img/add.png"
          alt="add"
          (click)="itemAdd()"
        />
      </div>
    </div>

    @for (formAvailableTimes of form().controls;
      track $index) {
      <div class="input-forms inputs-time">
        <mat-form-field>
          <mat-label>Descrição do horário</mat-label>
          <input
            matInput
            placeholder="EX: Café da manhã."
            [formControl]="formAvailableTimes.controls.description"
          />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Horário de início</mat-label>
          <input
            matInput
            type="time"
            placeholder="EX: 12:00"
            [formControl]="formAvailableTimes.controls.startTime"
          />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Horário de término</mat-label>
          <input
            matInput
            type="time"
            placeholder="EX: 15:00"
            [formControl]="formAvailableTimes.controls.endTime"
          />
        </mat-form-field>

        <div class="btn-add">
          <img
            src="assets/img/delete.png"
            alt="add"
            (click)="itemDelete($index)"
          />
        </div>
      </div>
    }
  </div>
</div>
